import { BookingType } from 'app/models/rtc/booking/constants';
import { tFunctionType } from 'app/services/localization';

/**
 * Mapping from BookingType to the name of the booking. The naming will have grammar specific to
 * the warning text in different languages, so this map cannot be relied on necessarily for all
 * languages.
 */
const BookingTypeNameGetters: { [K in BookingType]: (t: tFunctionType) => string } = {
  [BookingType.Lesson]: (t: tFunctionType) =>
    t('rtc.confirm-action.booking-type.lesson'),
  [BookingType.Meeting]: (t: tFunctionType) =>
    t('rtc.confirm-action.booking-type.meeting'),
  [BookingType.TestCall]: (t: tFunctionType) =>
    t('rtc.confirm-action.booking-type.test-call'),
  [BookingType.TeacherRegistration]: (t: tFunctionType) =>
    t('rtc.confirm-action.booking-type.teacher-registration'),
};

/**
 * Generate the logout warning message.
 *
 * The grammar for these messages is being interpolated, the corresponding localizations
 * should only be used in this file.
 */
export const getLogoutWarningMessage = (t: tFunctionType, bookingType: BookingType) =>
  t('rtc.confirm-action.message', {
    bookingType: BookingTypeNameGetters[bookingType](t),
    action: t('rtc.confirm-action.action.logout'),
  });

/**
 * Generate the warning message for when you are about to leave a call.
 *
 * The grammar for these messages is being interpolated, the corresponding localizations
 * should only be used in this file.
 */
export const getLeaveCallWarningMessage = (t: tFunctionType, bookingType: BookingType) =>
  t('rtc.confirm-action.message', {
    bookingType: BookingTypeNameGetters[bookingType](t),
    action: t('rtc.confirm-action.action.leave-call'),
  });
